import { getAccess } from "./permissionController";

export const modulesMapper = (modules: any[], roles: any[]): any[] => {
  const permittedModules: any[] = [];

  modules.forEach((module) => {
    if (module.value === "PROCUREMENT") {
      if (getAccess(roles, "PROCUREMENT_STORE_IN_CHARGE")) {
        permittedModules.push(module);
      }
    } else {
      permittedModules.push(module);
    }
  });

  return permittedModules;
};
